module.exports = __webpack_public_path__ + "static/media/icon-drop-down.d02276f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-drop-down.svg
// module id = 114
// module chunks = 0 1 2